// @flow

import type { NotificationsState } from "./types";

export const initialState: NotificationsState = {
  error: null,
  requestsInProgress: 0,
  myNotifications: {
    content: [],
    pagination: {
      pageNumber: 1,
      pageSize: 20,
      sort: { orders: [] },
      offset: 0,
    },
    totalElements: 0,
  },
  notificationsSearch: "",
};

export default initialState;
